import { useState, useEffect } from "react";

import { Outlet } from "react-router-dom";

import { Spinner } from "reactstrap";

import useAuth from "../hooks/useAuth";
import useRefreshToken from "../hooks/useRefreshToken";
import useLocalStorage from "../hooks/useLocalStorage";

import "./PersistLogin.styles.scss";

const PersistLogin = () => {
	const [isLoading, setIsLoading] = useState(true);
	const refresh = useRefreshToken();
	const { auth } = useAuth();
	const [persist] = useLocalStorage("persist", false);

	useEffect(() => {
		let isMounted = true;
		const verifyRefreshToken = async () => {
			try {
				await refresh();
			} catch (err) {
				console.error(err);
			} finally {
				isMounted && setIsLoading(false);
			}
		};
		!auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);

		return () => (isMounted = false);
	}, []);

	return (
		<>
			{!persist ? (
				<Outlet />
			) : isLoading ? (
				<div
					className="persist-login"
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						height: "100vh",
						backgroundImage:
							"linear-gradient(to left top,#bcbcbc,#c4c4c8,#ccccd4,#d2d5e1,#d8deee,#dee4f4,#e3e9f9,#e9efff,#f0f3ff,#f6f7ff,#fbfbff,#ffffff)",
					}}
				>
					<h5 className="text-gray font-size-20 mt-4 IRANSansBold">
						{process.env.REACT_APP_application_owner}
					</h5>
					<p className="text-gray-50 h5 mb-0 IRANSansLight">
						{process.env.REACT_APP_application_shortname}
					</p>
					<Spinner
						animation="border"
						style={{ marginBlockStart: "2rem", color: "#4077ad" }}
					/>
				</div>
			) : (
				<Outlet />
			)}
		</>
	);
};

export default PersistLogin;
